import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule, TranslationService } from '@spartacus/core';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomLandingModule } from 'src/app/modules/custom-landing/custom-landing.module';
import { GigyaService } from 'src/app/services/gigya.service';
import { SharedModule } from 'src/app/shared/shared.module';
declare var gigya: any;
@Component({
  selector: 'app-faceidmodal',
  imports: [CustomLandingModule, BrowserAnimationsModule, I18nModule, SharedModule],
  templateUrl: './faceidmodal.component.html',
  styleUrl: './faceidmodal.component.scss',
})
export class FaceidmodalComponent implements OnInit {
  @Input() modaltoopen;
  @Input() email;
  @Input() password;
  @Input() logindetails: any;
  loader: boolean = false;
  enableLoader: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private toast: ToastService,
    public gigyaService: GigyaService,
    private cd: ChangeDetectorRef,
    private translation: TranslationService
  ) {}
  ngOnInit(): void {
    console.log('logindetails...', this.logindetails);
    if (this.modaltoopen === 'firstTime') {
      this.registerFido();
    }
    this.enableLoader = false;
    this.cd.detectChanges();
  }
  close(reason?: string) {
    this.activeModal.close(reason);
  }
  registerFido() {
    this.enableLoader = true;
    this.gigyaService
      .showScreenSet(
        'FIDO-RegistrationLogin',
        'gigya-passkey-registration-screen',
        'auto'
      )
      .then((response: any) => {
        if (response?.closed == true) {
          this.close('success');
        } else {
          this.enableLoader = false;
          console.log('response....', response);
          this.cd.detectChanges();
          this.close('error');
        }
      })
      .catch((error: any) => {
        //this.toast.show(error.errorDetails || 'Error in registering passkey');
        console.log('error....', error);
        this.enableLoader = false;
        this.cd.detectChanges();
        this.close('error');
      });
  }
  loginAndRegister() {
    let toastshown=false;
    if ((!this.email || !this.password) && !this.logindetails) {
      this.translation
        .translate('home.loginForm.Biometrics.missingLogin')
        .subscribe((res) => {
          if (!toastshown) {
            this.toast.show(res);
            toastshown = true;
          }
        });
      this.enableLoader = false;
      this.cd.detectChanges();
      this.close('error');
    } else {
      this.gigyaService
        .login(
          this.email ? this.email : this.logindetails?.email,
          this.password ? this.password : this.logindetails?.password,
        )
        .then((res: any) => {
          this.enableLoader = false;
          this.cd.detectChanges();
          console.log('CDC login response...', res);
          if (res.errorCode === 0) {
            this.registerFido();
          } else {
            // this.toast.show('Error while adding the paaskey');
            this.translation
              .translate('home.loginForm.Biometrics.errorAdding')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toast.show(res);
                  toastshown = true;
                }
              });
            this.close('error');
          }
        })
        .catch((err: any) => {
          this.enableLoader = false;
          this.cd.detectChanges();
          this.close('error');
        });
    }
  }

  yesAllow() {
    var email = this.email;
    var password = this.password;
    console.log(email, password);
    this.enableLoader = true;
    this.cd.detectChanges();

    this.gigyaService.verifyLogin().then((res: any) => {
        if (res.errorCode === 0) {
          this.registerFido();
        } else {
          this.loginAndRegister()
        }
      }).catch((err: any) => {
        this.loginAndRegister();
      });
  }
  removeCredentials() {
    // let self = this;
    // gigya.accounts.auth.fido.getCredentials({
    //   callback: (response) => {
    //     if (response) {
    //       gigya.accounts.auth.fido.removeCredential({
    //         credentialId: response.credentials[0].Id,
    //         callback: (responseof) => {
    //           console.log('remove credentials response...', responseof);
    //           self.close();
    //         },
    //       });
    //     }
    //   },
    // });
    this.enableLoader = true;
    let toastshown=false;
    this.cd.detectChanges();
    this.gigyaService
      .removeCredentials()
      .then((res: any) => {
        this.enableLoader = false;
        console.log('remove credentials response...', res);
       // this.toast.show('Passkey removed successfully');
        this.translation
              .translate('home.loginForm.Biometrics.removesuccess')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toast.show(res);
                  toastshown = true;
                }
              });
        this.cd.detectChanges();
        this.close('success');
      })
      .catch((error: any) => {
        console.log('error....', error);
         this.translation
              .translate('home.loginForm.Biometrics.removeError')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toast.show(res);
                  toastshown = true;
                }
              });
        this.enableLoader = false;
        this.cd.detectChanges();
        this.close('error');
      });
  }
}
